import { RestSchemas } from '@/contexts/QueryProvider'
import { ColumnDef } from '@tanstack/react-table'
import { SortingHeaderButton } from '../../../../components/ui/DataTable/SortingHeaderButton'
import { NumberBadge } from '@/components/ui/DataTable/NumberBadge'
import { IconCommunityOutline } from '@icons/IconCommunityOutline'
import { RowActionsMenu } from './RowActionsMenu'

type MessagesApplicationsApplicationTeam = RestSchemas['Messages.Applications.ApplicationTeam']

export const appTeamsTableColumnsV2: ColumnDef<MessagesApplicationsApplicationTeam>[] = [
  {
    id: 'teamName',
    accessorFn: (row) => `${row.name} ${row.description}`,
    header: ({ column }) => <SortingHeaderButton column={column}>Team name</SortingHeaderButton>,
    cell: ({ row }) => (
      <div className="group flex items-start gap-x-4">
        <div className="bg-offwhite flex size-10 shrink-0 items-center justify-center rounded-full">
          <IconCommunityOutline className="size-5 text-muted-foreground" />
        </div>
        <div className="flex flex-col gap-y-1">
          <span className="text-base group-hover:underline">{row.original.name}</span>
          <span className="text-xs font-light leading-[1.1] text-muted-foreground">{row.original.description}</span>
        </div>
      </div>
    ),
    sortingFn: (rowA, rowB) => rowA.original.name.localeCompare(rowB.original.name),
    enableGlobalFilter: true,
    size: 250,
  },
  {
    id: 'projects',
    accessorKey: 'linkedProjectCount',
    header: 'Projects',
    cell: ({ cell }) => <NumberBadge value={cell.getValue() as number} />,
    enableGlobalFilter: true,
  },
  {
    id: 'users',
    accessorKey: 'linkedUserCount',
    header: 'Team members',
    cell: ({ cell }) => <NumberBadge value={cell.getValue() as number} />,
    enableGlobalFilter: true,
  },
  {
    id: 'roles',
    accessorKey: 'linkedRoleCount',
    header: 'Team roles',
    cell: ({ cell }) => <NumberBadge value={cell.getValue() as number} />,
    enableGlobalFilter: true,
  },
  {
    id: 'actions',
    cell: ({ row }) => (
      <div className="flex justify-end">
        <RowActionsMenu row={row.original} />
      </div>
    ),
  },
]
